import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/Navbar';
import CookieConsentBanner from './components/CookieConsentBanner';
import StickyMobileCTA from './components/StickyMobileCTA';
import HomePage from './pages/HomePage';

// Code-split: campaign pages are only loaded when /lp/* is hit, so the
// homepage bundle stays lean.
const CampaignLanding = lazy(() => import('./pages/CampaignLanding'));

function RouteFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="w-10 h-10 rounded-full border-4 border-indigo-200 border-t-indigo-500 animate-spin" />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <div
          className="min-h-screen relative"
          style={{
            background: 'linear-gradient(135deg, var(--bg-page-start) 0%, var(--bg-page-mid) 50%, var(--bg-page-end) 100%)',
          }}
        >
          {/* Background effects layer */}
          <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
            {/* Gradient orbs */}
            <div
              className="absolute -top-32 -left-32 w-[400px] h-[400px] rounded-full blur-3xl animate-float"
              style={{ background: 'radial-gradient(circle, #c7d2fe 0%, #e0e7ff 40%, transparent 70%)', opacity: 'var(--orb-1)' }}
            />
            <div
              className="absolute top-[40%] -right-20 w-[350px] h-[350px] rounded-full blur-3xl animate-float-delayed"
              style={{ background: 'radial-gradient(circle, #ddd6fe 0%, #ede9fe 40%, transparent 70%)', opacity: 'var(--orb-2)' }}
            />
            <div
              className="absolute bottom-[30%] left-[10%] w-[400px] h-[400px] rounded-full blur-3xl animate-float-slow"
              style={{ background: 'radial-gradient(circle, #c4b5fd 0%, #ddd6fe 40%, transparent 70%)', opacity: 'var(--orb-3)' }}
            />
          </div>

          {/* Navbar (route-aware: minimal variant on /lp/*) */}
          <Navbar />

          {/* Page content */}
          <main className="relative z-10">
            <Suspense fallback={<RouteFallback />}>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/lp/:slug" element={<CampaignLanding />} />
                <Route path="*" element={<HomePage />} />
              </Routes>
            </Suspense>
          </main>

          <CookieConsentBanner />
          <StickyMobileCTA />
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
